function _identity(x) {
  return x;
}

module.exports = _identity;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_identity.js
// module id = 479
// module chunks = 0